// src/pages/admin/index.tsx
import { Helmet } from 'react-helmet-async';
import AdminView, { AdminTab } from 'src/sections/admin/view';

interface Props {
  tab: AdminTab;
}

const TITLES: Record<AdminTab, string> = {
  cockpit: 'Administration - Cockpit',
  users: 'Administration - Users',
  sso: 'Administration - SSO Integration',
};

export default function AdminPage({ tab }: Props) {
  return (
    <>
      <Helmet>
        <title>{TITLES[tab]}</title>
      </Helmet>
      <AdminView tab={tab} />
    </>
  );
}
